<template>
    <div class="col-12 restaurant-picker">
        <vue-bootstrap-typeahead
                :data="restarantList"
                :serializer="s => s.addr"
                placeholder="Bitte dein McDonald's Lieblingsrestaurant eingeben*"
                ref="initialValue"
                v-model="typeaheadValue"
                @hit="getId(typeaheadId = $event.num)"
        >

            <div slot="suggestion" slot-scope="{ data }">
                {{data.addr}}
            </div>

        </vue-bootstrap-typeahead>
    </div>
</template>
<script>
    import Vue from 'vue';
    import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

    Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);

    export default {
        name: 'profileChangeFavouriteRestaurantComponent',
        components: {
            VueBootstrapTypeahead
        },
        data() {
            return {
                restarantList: [],
                typeaheadValue: '',
                typeaheadId: null
            };
        },
        watch: {
            typeaheadValue(val) {
                this.$emit('favoriteRestaurant', val);
            },
            typeheadId(val) {
                this.$emit('favoriteRestaurantID', val);
            }
        },
        methods: {
            fetchJson () {
                //https://www.mcdonalds.de/search/widget/jc/restaurants
                this.axios.get('https://mcduploaderst2.blob.core.windows.net/restaurants/juniorclub-restaurants-filtered.json')
                    .then(response => {
                        // JSON responses are automatically parsed.
                        // this.$store.commit('storeProfileData', response.data);

                        for (let i in response.data) {
                            let address = {
                                addr: response.data[i]['2'] + ', ' + response.data[i]['3'] + ', ' + response.data[i]['1'],
                                num: response.data[i]['0']
                            };
                            this.restarantList.push(address);
                        }
                    })
                    .catch(e => {
                        this.$store.commit('error', e);
                    });
            },
            // pretty dirty helper method because plugin does not support initial value
            setInitialRestaurant(value) {
                let favRest = this.restarantList.filter(rest => rest.num == value);
                this.$refs.initialValue.inputValue = favRest[0].addr;
            },
            getSeletedRestaurant: function () {
                return this.$refs.initialValue.typeheadId;
            },
            getId(val) {
                this.$emit('favoriteRestaurantID', val);
            }
        },
        created() {
            this.fetchJson();
        }
    };
</script>
